// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"purify_Regeneration__contentWrapper___3Z-nV","iconWrapper":"purify_Regeneration__iconWrapper___ysVML","centerWrapper":"purify_Regeneration__centerWrapper___23jYC","regenStart":"purify_Regeneration__regenStart___wQDxt","regenActive":"purify_Regeneration__regenActive___32tjI"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/Diesel/Regeneration/Regeneration.scss
// module id = 212
// module chunks = 0